import { CheckboxOptionType, Collapse, Grid, RadioChangeEvent } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CaretDown from "../../assets/images/icons/CaretDown";
import CustomRadioButton from "../../components/CustomRadioButton";
import { ALL_KEY } from "../../components/CustomRadioButton/enumerations/enumerations";
import { ContentWrapper } from "../../layouts/components";

import { Title } from "../../components";
import SkeletonCollapse from "./components/SkeletonCollapse";
import { FaqCategoryResponse, FaqProps, FaqResponse } from "./data";
import { useGetFaq, useGetFaqCategory } from "./hooks/faq.hooks";
import styles from "./styles.module.scss";
import "./styles.scss";

const Faq: React.FC<FaqProps> = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const { data: faqList, isLoading: loadingList } = useGetFaq({});
  const { data: category, isLoading: loadingCategory } = useGetFaqCategory({});
  const [options, setOptions] = useState<
    (string | number | CheckboxOptionType<any>)[]
  >([]);
  const [selectedCategory, setSelectedCategory] = useState<string | number>(
    ALL_KEY
  );

  const onChange = (e: RadioChangeEvent) => {
    setSelectedCategory(e.target.value);
  };

  useEffect(() => {
    if (!category) return;
    setOptions(
      category.map((category: FaqCategoryResponse) => {
        return {
          value: category.id,
          label: t([`${category.name}`]),
        };
      })
    );
  }, [category]);

  return (
    <ContentWrapper>
      <Title title={t("faq.title")} subtitle={t("faq.subtitle")} />
      <CustomRadioButton
        items={options}
        selectedValue={selectedCategory}
        onValueChange={onChange}
        loading={loadingCategory}
      />
      {loadingList ? (
        <SkeletonCollapse itemsCount={3} />
      ) : (
        <Collapse
          className={`custom-faq-collapse ${
            screens.md ? "" : screens.xs ? "small" : "mobile"
          }`}
          bordered={false}
          items={faqList?.filter(
            (faq: FaqResponse) =>
              faq.category_id === selectedCategory ||
              selectedCategory === ALL_KEY
          )}
          expandIcon={({ isActive }) => (
            <CaretDown
              className={`${styles.caretStyle} ${
                screens.sm ? "" : styles.mobile
              } ${isActive ? styles.active : ""}`}
            />
          )}
        />
      )}
    </ContentWrapper>
  );
};

export default Faq;
